export default "__VITE_ASSET__5c38000d__"